import { Controller } from 'react-hook-form';
import { FC } from 'react';

import { AboutFormControlProps } from '../../types';
import { CollapseCheckbox } from '../components/collapseCheckbox';
import { TermostatstyringRadio } from '../components/termostatstyringRadio';
import { Termostatstyring } from '../../../../../utils/registerEnums';
import { useAboutFormContext } from '../../utils';

export const Gasskamin: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue, trigger } = useAboutFormContext();
  return (
    <Controller
      name="oppvarming.oppvarmingGass.kamin.selected"
      control={control}
      render={({ field, fieldState }) => (
        <CollapseCheckbox
          labelKey="register.tekniskUtstyr.gassKamin.label"
          checked={!!field.value}
          onChange={(checked) => {
            field.onChange(checked);

            const newValue = checked ? { termostatstyring: Termostatstyring.Ukjent } : undefined;

            setValue('oppvarming.oppvarmingGass.kamin.value', newValue);
            trigger('oppvarmingSelection.oppvarmingGass');
          }}
          error={!!fieldState.error}
        >
          <Controller
            name="oppvarming.oppvarmingGass.kamin.value"
            control={control}
            render={({ field: { value, onChange } }) => (
              <TermostatstyringRadio
                value={value?.termostatstyring}
                labelKey="register.termostatstyring.kamin.label"
                informationKey="register.termostatstyring.kamin.information"
                error={fieldState.error}
                onChange={(val) =>
                  onChange({
                    termostatstyring: val as Termostatstyring
                  })
                }
              />
            )}
          />
        </CollapseCheckbox>
      )}
    />
  );
};
